import React from "react";
import PropTypes from "prop-types";
import SidebarLinks from "./SidebarLinks";
import { makeStyles } from "@material-ui/core/styles";
import { Drawer } from "@material-ui/core";

const Sidebar = (props) => {
  const useStyles = makeStyles((theme) => {
    theme.breakpoints.values.md = 992;
    return {
      "@global": {
        "*::-webkit-scrollbar-track": {
          padding: "2px 0",
          backgroundColor: "#edf2f7",
        },
        "*::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },

        "*::-webkit-scrollbar-thumb": {
          borderRadius: "10px",
          backgroundColor: "#5270CC",
        },
      },
      drawer: {
        zIndex: 1,
        width: 220,
        backgroundColor: "#102E88",
        marginTop: "64px",
        height: "calc(100% - 64px)",
        borderRadius: "1rem 1rem 0 0",
        border: "none",

        [theme.breakpoints.down("sm")]: {
          marginTop: "0",
          height: "100%",
          backgroundColor: "#FFFFFF",
        },
      },
    };
  });

  const { open, isSmallScreen, handleSidebarClose } = props;
  const classes = useStyles(props);

  return (
    <Drawer
      anchor="left"
      onClose={handleSidebarClose}
      open={open}
      variant={isSmallScreen ? "temporary" : "persistent"}
      classes={{ paper: classes.drawer }}
    >
      <SidebarLinks
        handleClose={handleSidebarClose}
        isSmallScreen={isSmallScreen}
      />
    </Drawer>
  );
};

Sidebar.propTypes = {
  handleSidebarClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

export default Sidebar;
